/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit'
import {
  getAllOrganizationApplications,
  getAllOrganizationApplicationsByOrgID,
  getAllOrganizationApplicationsByUserID,
  getStatus,
  getUserApplicationRole
} from './orgApplicationAction'

const initialState = {
  data: {},
  orgApplications: {},
  orgApplicationUserRole: '',
  networkStatus: ''
}
const orgApplicationSlice = createSlice({
  name: 'orgApplication',
  initialState,
  extraReducers: {
    [getAllOrganizationApplicationsByUserID.fulfilled]: (
      state,
      { payload }
    ) => {
      state.orgApplications = payload
    },
    [getAllOrganizationApplicationsByUserID.rejected]: (state, { payload }) => {
      state.orgApplications = {}
    },
    [getAllOrganizationApplications.fulfilled]: (state, { payload }) => {
      state.orgApplications = payload
    },
    [getAllOrganizationApplications.rejected]: (state, { payload }) => {
      state.orgApplications = {}
    },
    [getAllOrganizationApplicationsByOrgID.fulfilled]: (state, { payload }) => {
      state.orgApplications = payload
    },
    [getAllOrganizationApplicationsByOrgID.rejected]: (state, { payload }) => {
      state.orgApplications = {}
    },
    [getUserApplicationRole.fulfilled]: (state, { payload }) => {
      state.orgApplicationUserRole = payload
    },
    [getUserApplicationRole.rejected]: (state, { payload }) => {
      state.orgApplicationUserRole = ''
    },
    [getStatus.fulfilled]: (state, { payload }) => {
      if (JSON.stringify(state.networkStatus) !== JSON.stringify(payload)) {
        state.networkStatus = payload
      }
    },
    [getStatus.rejected]: (state, { payload }) => {
      state.networkStatus = {}
    }
  }
})

export default orgApplicationSlice.reducer
